import request from '@/service/lib/request'

/**
 * 鼠害 - 获取图片列表
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function getPictures(params) {
  return request({
    url: `/api/v1/rodents`,
    method: 'get',
    params
  })
}

export function xph(params) {
  return request({
    url: `/api/v1/rodents/xph/data`,
    method: 'get',
    params
  })
}
